<header class="wm-header">
  <a class="wm-brand" [routerLink]="homePath" (click)="closeNavigation()">
    <img class="wm-brand__logo" [src]="logoPath" alt="" aria-hidden="true" />
    <span class="wm-brand__name">{{ brandLabel }}</span>
  </a>

  <nav class="wm-nav" aria-label="Primary navigation">
    @for (link of navigationLinks(); track link.path) {
      <a
        class="wm-nav__link"
        [routerLink]="link.path"
        routerLinkActive="wm-nav__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeNavigation()"
      >
        <i [class]="link.iconClass" aria-hidden="true"></i>
        <span>{{ link.label }}</span>
      </a>
    }
  </nav>

  <div class="wm-header-end">
    <details
      class="wm-conn-badge"
      [class.wm-conn-badge--open]="connectionStatus() !== 'online' && connectionDebugLine()"
      [attr.open]="connectionStatus() !== 'online' && connectionDebugLine() ? '' : null"
    >
      <summary class="wm-conn-badge__summary" [attr.title]="connectionDebugLine() || connectionLabel()">
        <span
          class="wm-conn-dot"
          [class.wm-conn-dot--online]="connectionStatus() === 'online'"
          [class.wm-conn-dot--reconnecting]="connectionStatus() === 'reconnecting'"
          [class.wm-conn-dot--error]="connectionStatus() === 'error'"
          [class.wm-conn-dot--offline]="connectionStatus() === 'offline' || connectionStatus() === 'idle'"
          aria-hidden="true"
        ></span>
        <span class="wm-conn-badge__label">{{ connectionLabel() }}</span>
      </summary>
      @if (connectionDebugLine()) {
        <div class="wm-conn-debug">{{ connectionDebugLine() }}</div>
      }
    </details>

    <span class="wm-driver-counts">
      <span class="wm-driver-count wm-driver-count--free" [attr.title]="'Free drivers' + driverCountsScope()">
        <i class="fa fa-circle" aria-hidden="true"></i>
        <span>{{ driverCounts().free }}</span>
      </span>
      <span class="wm-driver-count wm-driver-count--busy" [attr.title]="'Busy drivers' + driverCountsScope()">
        <i class="fa fa-circle" aria-hidden="true"></i>
        <span>{{ driverCounts().busy }}</span>
      </span>
      <span class="wm-driver-count wm-driver-count--total" [attr.title]="'Total online drivers' + driverCountsScope()">
        <i class="fa fa-circle" aria-hidden="true"></i>
        <span>{{ totalDrivers() }}</span>
      </span>
    </span>

    <button
      class="wm-btn-icon"
      [class.wm-btn-icon--active]="notificationEnabled()"
      type="button"
      (click)="toggleNotification()"
      [title]="notificationEnabled() ? 'New order sound: ON' : 'New order sound: OFF'"
      [attr.aria-pressed]="notificationEnabled()"
    >
      <i class="fa fa-bell" aria-hidden="true"></i>
    </button>

    <button
      class="wm-btn-icon"
      [class.wm-btn-icon--active-warning]="cancelNotificationEnabled()"
      type="button"
      (click)="toggleCancelNotification()"
      [title]="cancelNotificationEnabled() ? 'Cancel sound: ON' : 'Cancel sound: OFF'"
      [attr.aria-pressed]="cancelNotificationEnabled()"
    >
      <i class="fa fa-fire" aria-hidden="true"></i>
    </button>

    <button
      class="wm-btn-icon"
      type="button"
      (click)="toggleTheme()"
      [title]="theme() === 'system' ? 'Theme: System (click for Light)' : theme() === 'light' ? 'Theme: Light (click for Dark)' : 'Theme: Dark (click for System)'"
    >
      @if (theme() === 'light') {
        <i class="fa fa-sun-o" aria-hidden="true"></i>
      } @else if (theme() === 'dark') {
        <i class="fa fa-moon-o" aria-hidden="true"></i>
      } @else {
        <i class="fa fa-adjust" aria-hidden="true"></i>
      }
    </button>

    @if (fullscreenSupported()) {
      <button
        class="wm-btn-icon"
        type="button"
        (click)="toggleFullscreen()"
        [title]="fullscreenActive() ? 'Exit fullscreen' : 'Enter fullscreen'"
      >
        <i
          class="fa"
          [class.fa-expand]="!fullscreenActive()"
          [class.fa-compress]="fullscreenActive()"
          aria-hidden="true"
        ></i>
      </button>
    }

    <div class="wm-account-menu" [class.wm-account-menu--open]="accountMenuOpen()">
      <button
        class="wm-btn wm-btn-ghost wm-btn-sm"
        type="button"
        (click)="toggleAccountMenu($event)"
        [attr.aria-expanded]="accountMenuOpen()"
      >
        {{ accountLabel() }}
        <i class="fa fa-caret-down" aria-hidden="true"></i>
      </button>

      @if (accountMenuOpen()) {
        <div class="wm-dropdown-menu wm-account-menu__dropdown">
          <button type="button" (click)="logout()">
            <i class="fa fa-sign-out" aria-hidden="true"></i>
            Logout
          </button>
        </div>
      }
    </div>

    <button
      class="wm-btn-icon wm-header__mobile-menu"
      type="button"
      (click)="toggleNavigation()"
      [attr.aria-expanded]="navigationOpen()"
      aria-label="Open navigation"
    >
      <i class="fa fa-bars" aria-hidden="true"></i>
    </button>
  </div>
</header>

@if (navigationOpen()) {
  <div class="wm-mobile-nav-backdrop" (click)="closeNavigation()" aria-hidden="true"></div>
  <nav class="wm-mobile-nav" aria-label="Mobile navigation">
    @for (link of navigationLinks(); track link.path) {
      <a
        class="wm-mobile-nav__link"
        [routerLink]="link.path"
        routerLinkActive="wm-mobile-nav__link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeNavigation()"
      >
        <i [class]="link.iconClass" aria-hidden="true"></i>
        <span>{{ link.label }}</span>
      </a>
    }
  </nav>
}

<main class="wm-app-content">
  <router-outlet />
</main>
